module.exports = __webpack_public_path__ + "static/media/my_pro_portal.39501e3f.png";